<template>
  <div class="offer">
    <v-app-bar app color="primary" dense class="header primaryText--text">
      <v-row>
        <v-col cols="3">
          <v-app-bar-nav-icon v-if="showLangSwitcher" @click="setNextLanguage" class="ml-2" style="width:auto;">
            <LanguageIcon></LanguageIcon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="6" class="d-flex justify-center align-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2">{{ $t("offer") }}</v-toolbar-title>
          </div>
        </v-col>

        <v-col cols="3" align-self="end" style="text-align:right"> </v-col>
      </v-row>
    </v-app-bar>

    <EasyRefresh ref="easyRefresh" :userSelect="false" :onRefresh="onPullDownRefresh">
      <template v-slot:header>
        <ClassicsHeader height="150" />
      </template>

      <v-container v-show="$store.getters.availablePromos.length > 0 || addPromoAllowed">
        <div class="promo-bar" v-show="addPromoAllowed">
          <v-row>
            <v-col cols="6" sm="4" md="3" lg="2"
              ><v-text-field
                dense
                filled
                hide-details
                v-model="promoCode"
                :placeholder="$t('checkout.enter_promo_code')"
              ></v-text-field
            ></v-col>
            <v-col class="d-flex align-center">
              <v-btn small rounded color="accent" class="accentText--text" @click="addPromo">{{
                $t("placeorder")
              }}</v-btn>
            </v-col>
          </v-row>
        </div>

        <v-row v-show="$store.getters.availablePromos.length > 0" class="pa-3 promo-list">
          <v-col
            class="promo-container pa-2"
            cols="6"
            sm="3"
            md="3"
            lg="2"
            xl="2"
            v-for="(promo, index) in $store.getters.availablePromos"
            :key="index"
            @click="selectPromo(promo)"
          >
            <v-card>
              <v-img v-if="getPromoImageSrc(promo) != null" :src="getPromoImageSrc(promo)"> </v-img>
              <div class="promo-content">
                <div :class="['promo-title', getPromoTitleSizeClass(promo)]">
                  <div v-if="$store.state.descrIndex == 1">
                    {{ promo.title1 }}
                  </div>
                  <div v-else-if="$store.state.descrIndex == 2">
                    {{ promo.title2 }}
                  </div>
                  <div v-else>
                    {{ promo.title }}
                  </div>
                </div>
                <div class="promo-detail">
                  <div v-if="$store.state.descrIndex == 1">
                    {{ promo.detail1 }}
                  </div>
                  <div v-else-if="$store.state.descrIndex == 2">
                    {{ promo.detail2 }}
                  </div>
                  <div v-else>
                    {{ promo.detail }}
                  </div>
                </div>
              </div>
              <!-- 
              <v-card-title class="promo-title"
                ><div v-if="$store.state.descrIndex == 1">{{ promo.title1 }}</div>
                <div v-else-if="$store.state.descrIndex == 2">{{ promo.title2 }}</div>
                <div v-else>{{ promo.title }}</div></v-card-title
              >
              <v-card-subtitle class="mb-2 promo-subtitle">
                <div v-if="$store.state.descrIndex == 1">{{ promo.detail1 }}</div>
                <div v-else-if="$store.state.descrIndex == 2">{{ promo.detail2 }}</div>
                <div v-else>{{ promo.detail }}</div>
              </v-card-subtitle> 
              -->
              <!--               
              <v-card-actions>
                <div v-if="getValidDate(promo) != ''" class="promo-valid-date">
                  {{ getValidDate(promo) }}
                </div>
              </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </EasyRefresh>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import LanguageIcon from "@/components/LanguageIcon.vue";

export default {
  components: {
    LanguageIcon,
  },

  data() {
    return {
      refreshing: false,
      promoCode: "",
    };
  },

  activated() {
    console.log("offer activated");

    this.reloadMemberPromos();

    this.$refs.easyRefresh.scrollTo(0, false);
  },

  computed: {
    addPromoAllowed() {
      if (this.$store.state.order.orderType != this.$store.state.OT_DINEIN && this.$store.state.promos.length > 0) {
        let promoOi = this.$store.state.order.orderItems.find(oi => oi.promo != null);
        return promoOi == null;
      } else return false;
    },
  },

  methods: {
    async reloadMemberPromos() {
      this.refreshing = true;
      let memberCode = this.$store.state.member.MemberCode;
      this.updateMemberPromos(memberCode)
        .then(() => {
          this.refreshing = false;
        })
        .catch(() => {
          this.refreshing = false;
        });
    },

    onPullDownRefresh(done) {
      this.reloadMemberPromos().then(() => {
        done();
      });
    },

    getValidDate(promo) {
      let validDate = "";
      if (promo.ValidFrom != null && promo.ValidFrom != "") {
        let date = this.toDate(promo.ValidFrom);
        validDate = date.toLocaleString();
      }
      if (promo.ValidTo != null && promo.ValidTo != "") {
        let date = this.toDate(promo.ValidTo);
        validDate += (validDate == "" ? this.$t("expires_on") + " " : " - ") + date.toLocaleString();
      }
      return validDate;
    },

    getPromoImageSrc(promo) {
      let url = null;
      if (!this.isEmptyObject(promo.Image)) {
        if (promo.Image.AltUrl != "") url = promo.Image.AltUrl;
        else if (promo.Image.DownloadPath != "") url = promo.Image.DownloadPath;
      }

      return url;
    },

    getPromoTitleSizeClass(promo) {
      let pts_class = "promo-title-size-normal";
      if (promo != null && promo.CustomData != null && promo.CustomData.TitleSize != null) {
        if (promo.CustomData.TitleSize == "small") pts_class = "promo-title-size-small";
        else if (promo.CustomData.TitleSize == "large") pts_class = "promo-title-size-large";
        else if (promo.CustomData.TitleSize == "xlarge") pts_class = "promo-title-size-xlarge";
      }

      return pts_class;
    },

    async selectPromo(promo) {
      let addPromo = true;
      if (this.$store.state.store == null) {
        addPromo = false;
        let store = await this.$root.storeListDialog({ storeClickAccept: true });
        if (store != null) {
          let memberCode = this.$store.state.member.MemberCode;
          let promos = await this.getMemberPromos(memberCode, store.companyCode);
          let _promo = promos.find(p => p.PromoteCode == promo.PromoteCode);
          if (_promo == null) {
            this.$root.messageDialog(
              this.$t("error_alert_title"),
              "",
              this.$t("error_promo_redeemed", { promo: promo.Title })
            );
            return;
          }

          this.refreshing = true;
          let selected = (await this.storeSelected(store)) && (await this.reloadMenu());
          this.refreshing = false;

          addPromo = selected;
        } else return;
      }

      if (addPromo) {
        if (this.$store.state.order.orderType == this.$store.state.OT_DINEIN) {
          this.$root.messageDialog(this.$t("error_alert_title"), "", this.$t("error_not_accept_promo_dinein"));
          return;
        }
      }

      if (addPromo) {
        let promoValidated = await this.validatePromo(promo);
        if (promoValidated) {
          this.addPromoToCart(promo);
        }
      }
    },

    async addPromo() {
      console.log(this.promoCode);

      let memberCode;
      if (this.$store.state.member != null) memberCode = this.$store.state.member.MemberCode;
      let getResp = await this.rest_getMemberPromo(memberCode, this.promoCode);
      let promo = null;
      if (getResp.result == "ok") {
        promo = getResp.record;

        this.addExInfoToPromo(promo);
      }

      if (promo != null) {
        this.selectPromo(promo).then(() => {
          this.promoCode = "";
        });
      } else {
        this.$root.messageDialog(
          this.$t("error_alert_title"),
          "",
          this.$t("error_promo_redeemed", { promo: this.promoCode })
        );

        this.promoCode = "";
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.offer {
  background-color: var(--v-background-base);
  height: 100%;
  //height: calc(100vh - #{$header-height} - #{$bottom-toolbar-height});
}

.v-list {
  //padding: 12px !important;
  //margin: 16px;
  padding: 16px;
  background-color: var(--v-background-base);
}
.v-list-item {
  padding: 0px;
  //background-color: white;
}

.v-card__title {
  //word-wrap: break-word !important;
  word-break: normal !important;
}

.promo-bar {
  .col {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.promo-list {
  padding-bottom: calc(48px + #{$bottom-toolbar-height}) !important;

  .promo-container {
    .v-card {
      width: 200px;
      height: 300px;
    }

    padding: 0px;
    padding-bottom: 8px;

    .v-image {
      //border-bottom-right-radius: 24px;
      //border-bottom-left-radius: 4px;
      max-height: 100px;
      max-width: 200px;
    }

    .promo-content {
      //max-height: 114px;
      height: 160px;
      //position: absolute;
      //bottom: 0px;
      //top: 36px;
      //top: 100px;
      overflow: auto;
      width: 100%;
      padding: 8px;
      //background-color: rgba(white, 0.9);
      .promo-title {
        font-weight: bold;
      }
      .promo-detail {
        font-size: 0.8em;

        /*         overflow: auto;
        white-space: pre-line;
        text-overflow: ellipsis;
        padding-right: 5px; */

        /*         display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;    */
      }

      .promo-title-size-small {
        font-size: 0.85em;
      }
      .promo-title-size-normal {
        font-size: 1em;
      }
      .promo-title-size-large {
        font-size: 1.5em;
      }
      .promo-title-size-xlarge {
        font-size: 2em;
      }
    }

    /*     .promo-title {
      font-size: 1.2em;
    }

    .promo-subtitle {
      font-size: 1.2em;
    } */
  }
}

/* .promo-remark {
  font-size: 1em;
  margin-top: -12px;
}

.promo-valid-date {
  font-size: 0.7em;
  position: absolute;
  bottom: 0px;
  padding: 8px 0px;

  white-space: nowrap;
  overflow: hidden;
  //text-align: right;
  max-height: 30px;
  width: 100%;
  color: grey;
  border-top: solid 1px var(--v-background-base);
} */
</style>
